<h1 mat-dialog-title>{{'dialogs.userActionForbiddenDialogComponent.title' | translate}}</h1>
<div mat-dialog-content>


  <ng-container *ngFor="let error of data.errors">

    <p *ngIf="'messages.errors.' + error.code | hasTranslation; else errorMessage">
      {{'messages.errors.' + error.code | translate}}
    </p>

    <ng-template #errorMessage>
      <p>{{error.message}}</p>
    </ng-template>

  </ng-container>


</div>
